export default {
  ignoreLogs() {},
  ignoreAllLogs() {},
};
